// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es6:true*/
(function(){
let define;
let is_node = typeof module=='object' && module.exports;
if (!is_node)
    define = self.define;
else
    define = require('../../../util/require_node.js').define(module, '../');
define(['lodash4', '/util/date.js', '/www/cp/pub/util.js', '/util/url.js',
    '/util/storage.js', '/util/ajax.js', '/util/etask.js', '/www/lum/pub/plans.js',
    '/www/util/pub/perr.js', '/www/util/pub/util.js',
    '/www/lum/pub/util/domain.js', '/www/lum/pub/util/ga.js'],
    (_, date, cp_util, zurl, storage, ajax, etask, zplans, perr,
    pub_util, domain_util, ga_util_all)=>
{
const {assign} = Object;
var is_mdoc = !is_node&&/^mdoc/.test(window.location.hostname);
const ga_util = is_mdoc?undefined:ga_util_all;
const E = {};

E.uuid = ()=>{
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c){
      let r = Math.random() * 16 | 0;
      let v = c=='x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
};

E.uuid_persistent = ()=>{
    let uuid;
    if (storage.get)
    {
        uuid = storage.get('uuid_persistent');
        if (!uuid)
        {
            uuid = E.uuid();
            storage.set('uuid_persistent', uuid);
        }
    }
    else
        return E.uuid();
    return uuid;
};

E.perr = (id, info)=>{
    if (!/^(www|be)/.test(id))
        throw new Error('invalid perr id, see svc/lib/perr.js');
    return perr.perr({id, info: info.info||info});
};

E.metric_trim = (metric, left, right)=>{
    let from = metric.from, step = metric.step, data = metric.data;
    if (right<from || left>from + step*data.length)
        return {from: left, step: step, data: []};
    left = Math.max(0, Math.ceil((left-from)/step));
    right = Math.min(data.length, Math.floor((right-from)/step)+1);
    return {from: from + left*step, step: step, data: data.slice(left, right)};
};

E.metric_pad = (metric, left, right, def)=>{
    let from = metric.from, step = metric.step, data = metric.data;
    let to = from + step*metric.data.length, i;
    let lpad = [];
    let n = Math.max(0, Math.ceil((from-left)/step));
    let new_from = from - n*step;
    for (i=0; i<n; i++)
        lpad.push(def);
    let rpad = [];
    for (i=0, n=Math.max(0, Math.ceil((right-to)/step)); i<n; i++)
        rpad.push(def);
    return {from: new_from, step: step, data: lpad.concat(data, rpad)};
};

E.metric_repack = metric=>{
    let from = metric.from, step = metric.step;
    return metric.data.map((v, j)=>[v, from + step*j]);
};

E.disable_zones = (customer, now, zones)=>{
    now = now||date();
    zones = zones ? _.pick(customer.zones, zones) : customer.zones;
    let update = [];
    if (!customer || !customer.zones)
        return update;
    Object.keys(zones).forEach(z=>{
        let plan = zplans.get_latest_plan(customer, z);
        if (!plan || plan.disable)
            return;
        let new_plan = assign(_.cloneDeep(plan), {disable: 1, start: now});
        if (new_plan.end)
            delete new_plan.end;
        customer.zones[z].plan = new_plan;
        update.push({$set: {[`customer.zones.${z}.plan`]: new_plan}});
    });
    return update.length ? cp_util.merge_date_sequence_update(update) : [];
};

E.has_active_resident_zones = cust=>_.some(cust&&cust.zones, zone=>{
    let plan = zplans.get_latest_plan(zone);
    return plan && !plan.disable && {resident: 1, unblocker: 1}[plan.type];
});

E.timezones = [
    ['-12:00', 'International Date Line\u00A0West'],
    ['-11:00', 'Midway\u00A0Island, Samoa'],
    ['-10:00', 'Hawaii'],
    ['-09:00', 'Alaska'],
    ['-08:00', 'Pacific\u00A0Time (US\u00A0&\u00A0Canada)'],
    ['-07:00', 'Arizona'],
    ['-06:00', 'Central\u00A0America'],
    ['-05:00', 'Bogota, Lima, Quito, Rio\u00A0Branco'],
    ['-04:00', 'Atlantic\u00A0Time (Canada)'],
    ['-03:30', 'Newfoundland'],
    ['-03:00', 'Brasilia'],
    ['-02:00', 'Mid-Atlantic'],
    ['-01:00', 'Cape\u00A0Verde\u00A0Is.'],
    ['+00:00', 'Dublin, Edinburgh, Lisbon, London'],
    ['+01:00', 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna'],
    ['+02:00', 'Athens, Bucharest, Istanbul'],
    ['+03:00', 'Moscow, St.\u00A0Petersburg, Volgograd'],
    ['+03:30', 'Tehran'],
    ['+04:00', 'Abu\u00A0Dhabi, Muscat'],
    ['+04:30', 'Kabul'],
    ['+05:00', 'Yekaterinburg'],
    ['+05:30', 'Chennai, Kolkata, Mumbai, New\u00A0Delhi'],
    ['+05:45', 'Kathmandu'],
    ['+06:00', 'Almaty, Novosibirsk'],
    ['+06:30', 'Yangon (Rangoon)'],
    ['+07:00', 'Bangkok, Hanoi, Jakarta'],
    ['+08:00', 'Beijing, Chongqing, Hong\u00A0Kong, Urumqi'],
    ['+09:00', 'Osaka, Sapporo, Tokyo'],
    ['+09:30', 'Adelaide'],
    ['+10:00', 'Canberra, Melbourne, Sydney'],
    ['+11:00', 'Magadan, Solomon\u00A0Is., New\u00A0Caledonia'],
    ['+12:00', 'Fiji, Kamchatka, Marshall\u00A0Is.'],
];

E.ga_set = (dim, val)=>{
    window.ga('set', dim, val); };

E.signup_modal_event = (action, label)=>{
    let event_name = signup_modal_event_actions[action];
    window.ga('send', 'event', 'network_type_selection_dialog', event_name,
        label);
};
const signup_modal_event_actions = {
    zone_on: 'switch network type on', zone_off: 'switch network type off',
    learn_more: 'click learn more', start: 'click start',
};

E.payment_event = (action, label)=>{
    let event_name = payment_event_actions[action];
    window.ga('send', 'event', 'auth_payment_method_dialog', event_name,
        label);
};
const payment_event_actions = {
    close: 'click close', select_payment: 'select payment method',
    success: 'successful authorization', failure: 'failed authorization',
};

E.closed_payment_event = action=>{
    let event_name = closed_payment_event_actions[action];
    window.ga('send', 'event', 'closed_payment_method_modal', event_name);
};
const closed_payment_event_actions = {later: 'click do later', add_payment:
    'click add payment'};

E.first_login = (user, customer, history)=>{
    if (storage.get('lum_first_login')==user._id)
        return;
    return etask([()=>ajax.json({url: '/users/first_login',
        qs: {customer_id: customer.id}, method: 'POST'}),
        res=>{
            storage.set('lum_first_login', user._id);
            storage.set('lum_new_user', res.new_user ? 'true' : 'false');
            if (!res.new_user)
                return;
            ga_util.gtm_event('cp-login-first');
            if (user.provider == 'google')
            {
                ga_util.gtm_event('signup-g',
                    {'signup-g-page': user.signup_page});
            }
            storage.set('lum_first_login_zones', 1);
            ga_util.onboarding_event(8, location.pathname);
            let redirect = _.get(user, 'product.sdk') && '/sdk/cp';
            if (!redirect)
                return;
            let qs = zurl.qs_parse((window.location.search||'').substr(1));
            if (qs.email_verify_success)
            {
                redirect += '?email_verify_success='
                    +encodeURIComponent(qs.email_verify_success);
            }
            history.push(redirect);
        }]);
};

E.filter_options = (options, filter_value)=>{
    filter_value = filter_value.toLowerCase();
    let limit = 15, hit_limit = false;
    let res = _.reduce(options, (acc, option)=>{
        if (acc.length==limit)
            hit_limit = true;
        if (acc.length<limit && filter_options_filter(option, filter_value))
            acc.push(option);
        return acc;
    }, []);
    let extra = {value: '', label: 'Start typing to see more', disabled: true};
    return hit_limit ? res.concat(extra) : res;
};

const filter_options_filter = (option, filter_value)=>{
    if (!filter_value)
        return true;
    return String(option.value).toLowerCase().indexOf(filter_value)>=0
        || String(option.label).toLowerCase().indexOf(filter_value)>=0
        || String(option.c_name).toLowerCase().indexOf(filter_value)>=0;
};

E.send_res_payment_ga = (cid, info)=>etask([()=>{
    if (storage.get('residential_payment_ga'))
        return;
    storage.set('residential_payment_ga', 1);
    E.perr('www_lum_res_payment_inited_frontend', info);
    window.ga('send', 'event', 'payment', 'residential initiated');
    return ajax({method: 'POST', url: '/users/update_inited',
        qs: {customer_id: cid, residential_payment_ga: 1}});
}]);

E.is_skip_pmethod = customer=>customer.onboarding&&
    customer.onboarding.skip_pmethod&&
    /* XXX bruno/itamar: disabld billing check, confirm if can be fully removed
    ['ccardg2s', 'paypalbt', 'paypalg2s']
    .every(k=>!customer.onboarding['billing_set_method_'+k])&&
    !customer.onboarding.billing&&*/
    _.get(customer, 'bizdev.lead.not_signed')&&
    date(_.get(customer, 'bizdev.lead.outbound_exp_date') ||
        date.add(customer.start, {months: 2}))>=date.align(date(), 'DAY') &&
    !window.location.pathname.includes('/cp/setting/billing') &&
        !window.location.pathname.includes('/cp/billing')
    || customer.verified_company;

E.is_selenium = ()=>typeof window!='undefined' && window.hola_selenium_test;

E.validate_file = pub_util.validate_file;

const add_line_to_context_result = (line, context)=>{
    if (!line)
        return;
    context.result+=line;
    context.read_count++;
};
// opt:
//   skip_empty_lines: boolean
//   read_limit: number, stop reading file contents after reading
//     <read_limit> bytes. If this option is set, function may read less than
//     <maxlines> lines
E.read_n_lines = (file, maxlines, opt = {})=>etask(function*(){
    if (!maxlines)
    {
        let results_et = etask.wait();
        let fr = new FileReader();
        fr.onload = e=>results_et.continue(e.target.result);
        fr.onerror = results_et.throw_fn();
        fr.readAsText(file, 'utf-8');
        return {result: yield results_et, read_whole_file: true};
    }
    let on_load = (context, cb)=>{
        context.results += context.decoder.decode(context.fr.result,
            {stream: true});
        let lines = context.results.split('\n');
        context.results = lines.pop();
        if (opt.skip_empty_lines)
            lines = lines.filter(l=>l&&l.length);
        if (context.read_count + lines.length > maxlines)
            lines = lines.slice(0, maxlines - context.read_count);
        for (let i=0; i<lines.length; i++)
            add_line_to_context_result(lines[i] + '\n', context);
        context.offset += context.chunk_size;
        cb();
    };
    opt.on_file_size_reached = context=>
        add_line_to_context_result(context.results, context);
    let {result, read_whole_file, read_count} =
        yield _read_n(file, maxlines, on_load, opt);
    return {result, read_whole_file, read_lines_count: read_count};
});

E.read_n_top_level_obj = (file, n, opt = {})=>etask(function*(){
    if (file.type!='application/json')
        throw new Error('Invalid file type');
    let parenthases_count = 0;
    let is_first = true;
    let in_quotes = false;
    let last_char;
    let on_load = (context, cb)=>{
        let decoded = context.decoder.decode(context.fr.result,
            {stream: true});
        for (let i in decoded)
        {
            let char = decoded[i];
            if (char=='"' && ![last_char, decoded[i-1]].includes('\\'))
                in_quotes = !in_quotes;
            last_char = i==decoded.length-1 ? char : null;
            if (!in_quotes && char=='{')
                parenthases_count++;
            if (parenthases_count)
                context.results += char;
            if (!in_quotes && char=='}' && --parenthases_count==0)
            {
                if (!is_first)
                    context.results = ',' + context.results;
                context.result += context.results;
                is_first = false;
                if (n==++context.read_count)
                    break;
                context.results = '';
            }
        }
        context.offset += context.chunk_size;
        cb();
    };
    let {result, read_whole_file, read_count} =
        yield _read_n(file, n, on_load, opt);
    result = `[${result}]`;
    return {result, read_whole_file, read_objects_count: read_count};
});

const _read_n = (file, n, on_load, opt = {})=>etask(function*(){
    let {read_limit, on_file_size_reached} = opt;
    let context = {
        decoder: new TextDecoder(),
        fr: new FileReader(),
        result: '',
        results: '',
        read_count: 0,
        offset: 0,
        chunk_size: read_limit ? Math.min(10000, read_limit) : 10000,
    };
    let complete_ets = etask.wait();
    let read_whole_file = false;
    context.fr.onload = ()=>on_load(context, seek);
    context.fr.onerror = complete_ets.throw_fn();
    let seek = ()=>{
        if (context.read_count==n)
        {
            read_whole_file = context.offset>=file.size;
            return complete_ets.return();
        }
        if (context.offset!=0 && context.offset>=file.size)
        {
            if (on_file_size_reached)
                on_file_size_reached(context);
            read_whole_file = true;
            return complete_ets.return();
        }
        if (read_limit && context.offset>=read_limit)
            return complete_ets.return();
        let slice = file.slice(context.offset,
            context.offset+context.chunk_size);
        context.fr.readAsArrayBuffer(slice);
    };
    seek();
    yield complete_ets;
    return {result: context.result, read_whole_file,
        read_count: context.read_count};
});

E.company_fields = {
    name: {label: 'Name', immutable: 1},
    country: {label: 'Country', immutable: {IL: 1, US: 1}},
    state: {label: 'State', immutable: {US: 1}},
    city: {label: 'City'},
    zip_code: {label: 'ZIP code'},
    address: {label: 'Address'},
    phone: {label: 'Phone number'},
    tax_num: {label: 'Tax ID', immutable: 1, root_immutable: 1},
    purchase_order: {label: 'PO number', immutable: 1},
};

E.e2obj = err=>{
    let obj;
    try {
        if (typeof err=='string')
            return {mesage: err};
        let message = err.message;
        let stack = (err.stack||'').split('\n').map(v=>_.trim(v))
            .filter(v=>v && !v.includes(err.message))
            .filter(v=>!/^at Generator.next \(<anonymous>\)/.test(v))
            .filter(v=>!/^at .*\/regenerator-runtime\.js/.test(v))
            .filter(v=>!/^at .*internal\/timers\.js/.test(v))
            .filter(v=>!/^at .*\/etask\.js/.test(v))
            .filter(v=>!/^at .*\/mocha\/lib\/runner\.js/.test(v));
        // duplicate {message, stack} is to ensure 'natural' field order
        obj = Object.assign({message, stack}, err, {message, stack});
    } catch(e){
        obj = err;
    }
    delete obj.etask;
    return obj;
};

E.init = ()=>{
    perr.init({perr_url: domain_util.is_cn() ? 'perr.luminati-china.biz' :
        'perr.brightdata.com'});
};

if (!is_mdoc)
    E.init();

return E; }); }()); // eslint-disable-line
